module.exports = __webpack_public_path__ + "img/icon-fb.897360a4.svg";